var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyTraySvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "408.302px",
    height: "408.301px",
    viewBox: "0 0 408.302 408.301",
    style: {
      enableBackground: "new 0 0 408.302 408.301"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M396.185,149.843l0.18-0.288l-82.121-88.631H89.928l-75.7,86.181l-5.029,5.789l0.441,0.429 C3.39,162.964,0,174.253,0,185.794v101.823c0,32.948,26.823,59.76,59.774,59.76h288.768c32.948,0,59.76-26.806,59.76-59.76V185.8 C408.29,172.734,404.032,160.184,396.185,149.843z M300.348,92.75l30.841,33.279h-83.647V157.4 c0,17.579-17.51,20.209-27.946,20.209h-30.891c-10.439,0-27.953-2.63-27.953-20.209v-31.372H75.096l29.246-33.279H300.348z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTraySvgrepoCom);
export default __webpack_public_path__ + "static/media/empty-tray-svgrepo-com.a206cdcaaac7ea46d5c809d0b9626883.svg";
export { ForwardRef as ReactComponent };